export interface PincodeLookupResult {
    city: string;
    state: string;
}

const PINCODE_API_BASE = "https://api.postalpincode.in/pincode";

export const fetchPincodeDetails = async (
    pincode: string
): Promise<PincodeLookupResult | null> => {

    const response = await fetch(
        `${PINCODE_API_BASE}/${pincode}`
    );

    if (!response.ok) {
        return null;
    }

    const data = await response.json();

    const result = Array.isArray(data) ? data[0] : null;

    if (
        !result ||
        result.Status !== "Success" ||
        !Array.isArray(result.PostOffice) ||
        result.PostOffice.length === 0
    ) {
        return null;
    }

    const firstOffice = result.PostOffice[0];

    if (!firstOffice.District || !firstOffice.State) {
        return null;
    }

    return {
        city: firstOffice.Block,
        state: firstOffice.State,
    };
};